"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageWidgetCell = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const IconWithText_1 = require("../../../../IconWithText/IconWithText");
require("./types");
exports.StorageWidgetCell = react_1.default.memo(({ icon, title, description, secondTitle, secondDescription }) => {
    return (react_1.default.createElement(components_1.StackView, { gap: components_1.STACK_GAP.m, direction: components_1.STACK_DIRECTION.row, align: components_1.STACK_ALIGN.start },
        react_1.default.createElement(components_1.Icon, { src: icon, size: components_1.ICON_SIZES.xl }),
        react_1.default.createElement(components_1.StackView, { gap: components_1.STACK_GAP.xs, direction: components_1.STACK_DIRECTION.column },
            react_1.default.createElement(IconWithText_1.IconText, { text: title, size: components_1.TEXT_SIZE.m }),
            react_1.default.createElement(IconWithText_1.IconText, { text: description, size: components_1.TEXT_SIZE.l, isDescription: true }),
            secondTitle && react_1.default.createElement(IconWithText_1.IconText, { text: secondTitle, size: components_1.TEXT_SIZE.m, isDescription: true }),
            secondDescription && (react_1.default.createElement(IconWithText_1.IconText, { text: secondDescription, size: components_1.TEXT_SIZE.l, isDescription: true })))));
});
//# sourceMappingURL=StorageWidgetCell.js.map